import { createInlineOverlay, activeOverlays } from "./utils";
import { uploadAndSendFile } from "./media";

export function showAttachmentMenu(anchorBtn, composer) {
  if (anchorBtn.classList.contains("is-active") && activeOverlays.has("attachment")) {
    activeOverlays.get("attachment").close();
    return;
  }

  const menu = document.createElement("div");
  menu.className = "bryght-attachment-menu";
  
  const svgDoc = document.getElementById("tpl-icon-doc")?.innerHTML || "";
  const svgMedia = document.getElementById("tpl-icon-media")?.innerHTML || "";
  const svgCamera = document.getElementById("tpl-icon-camera")?.innerHTML || "";

  const overlay = createInlineOverlay({
    anchor: anchorBtn,
    content: menu,
    group: "attachment",
    align: "left",
    gap: 8,
    onClose: () => {
      anchorBtn.classList.remove("is-active");
    }
  });

  const btnDoc = document.createElement("button");
  btnDoc.className = "bryght-attachment-btn";
  btnDoc.innerHTML = `<span class="icon">${svgDoc}</span> Dokument`;
  btnDoc.onclick = () => { overlay.close(); composer.querySelector(".bryght-composer-file--doc").click(); };
  
  const btnMedia = document.createElement("button");
  btnMedia.className = "bryght-attachment-btn";
  btnMedia.innerHTML = `<span class="icon">${svgMedia}</span> Foto & Video`;
  btnMedia.onclick = () => { overlay.close(); composer.querySelector(".bryght-composer-file--media").click(); };
  
  const btnCamera = document.createElement("button");
  btnCamera.className = "bryght-attachment-btn";
  btnCamera.innerHTML = `<span class="icon">${svgCamera}</span> Kamera`;
  btnCamera.onclick = () => { overlay.close(); composer.querySelector(".bryght-composer-file--camera").click(); };
  
  menu.append(btnDoc, btnMedia, btnCamera);
  
  anchorBtn.classList.add("is-active");
  document.body.appendChild(overlay.element);
}

// `roomId` may be a resolver function (see uploadAndSendFile): a draft has no
// room until this GIF creates it.
export function showGifPicker(anchorBtn, roomId, client, composer) {
  const gifPickerWrapper = document.querySelector("#chat-container").nextElementSibling;
  if (!gifPickerWrapper || !gifPickerWrapper.matches("[data-controller~='gif-picker']")) {
    console.error("GIF picker wrapper not found");
    return;
  }

  gifPickerWrapper.dispatchEvent(new CustomEvent("bryght-chat:open-gif"));

  const onGifSelected = async (e) => {
    const { url } = e.detail;
    gifPickerWrapper.removeEventListener("gif-picker:selected", onGifSelected);
    
    try {
      const blobRes = await fetch(url);
      const blob = await blobRes.blob();
      const file = new File([blob], "gif.gif", { type: "image/gif" });
      uploadAndSendFile(client, roomId, file, composer);
    } catch(err) {
      console.error("Failed to send GIF", err);
    }
  };
  
  if (gifPickerWrapper._bryghtGifListener) {
    gifPickerWrapper.removeEventListener("gif-picker:selected", gifPickerWrapper._bryghtGifListener);
  }
  gifPickerWrapper._bryghtGifListener = onGifSelected;
  gifPickerWrapper.addEventListener("gif-picker:selected", onGifSelected);
}
